/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { BlIcon, BlIconType } from '@blend/shared-react';
import { colors } from '@blend/consumer-components';
import { LinkButtonWrapper } from '@components/LinkButton/LinkButtonWrapper';
import { LinkButtonContentWrapper } from '@components/LinkButton/LinkButtonContentWrapper';
import { LinkButtonTextWrapper } from '@components/LinkButton/LinkButtonTextWrapper';

export namespace ContextualHelpListItemModalTrigger {
  export interface Props {
    icon?: BlIconType;
    isInline?: boolean;
    openModal: () => void;
    color?: string;
  }
}

export const ContextualHelpListItemModalTrigger: React.FC<ContextualHelpListItemModalTrigger.Props> = ({
  color,
  openModal,
  isInline,
  children,
  icon,
}) => {
  const isInlineText = isInline && !icon;
  return (
    <LinkButtonWrapper aria-haspopup="dialog" onClick={openModal} fake={isInlineText} color={color || colors.reflex}>
      <LinkButtonContentWrapper isInline={isInline} isInlineText={isInlineText}>
        {icon && <BlIcon icon={icon} />}
        <LinkButtonTextWrapper isInline={isInline} isInlineText={isInlineText}>
          {children}
        </LinkButtonTextWrapper>
      </LinkButtonContentWrapper>
    </LinkButtonWrapper>
  );
};
